
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookings/search",
      function () {
        return require("private-next-pages/bookings/search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookings/search"])
      });
    }
  